import { BankEligibilityBeneficialOwner } from '@/domains/Business/types'
import { getFullAddress } from '@/lib/address'
import { Typography } from '@/shared/ui'

type Props = {
  owner: BankEligibilityBeneficialOwner
}

export const OwnerAddressCell = ({ owner }: Props) => {
  return (
    <div className="flex items-center pr-4">
      <Typography className="text-neutral-gray-600">
        {getFullAddress(owner.address)}
      </Typography>
    </div>
  )
}
